import { DEFAULT_VIEWER } from '../constants'

export const initialViewerState = {
  viewer: { ...DEFAULT_VIEWER },
}

